import Vue from 'vue'
import store from '../store/index'
import VueRouter from 'vue-router'
import About from '../views/About.vue'
import Login from '../views/Login.vue'
import { sso } from "../core/api/index"
import MyProfile from '../views/MyProfile.vue'
import MyBookings from '../views/MyBookings.vue'
import MyNominees from '../views/nominee/MyNominees.vue'
import { getFinancialYears } from '../core/staff-helper'
import StaffHeader from '../components/layout/StaffHeader.vue'
import BookLeisureTravel from '../views/home/BookLeisureTravel.vue'

Vue.use(VueRouter)

let firstLoad = true;
const LOGIN_NAME = "Login";
const INDEX_NAME = "BookLeisureTravel";
const routes = [
  // {
  //   path: '/uikit',
  //   name: 'Home',
  //   component: () => import("../views/Home.vue");
  // },
  {
    path: '/about',
    name: 'About',
    components: { default: About, header: StaffHeader }
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/login',
    name: LOGIN_NAME,
    components: { default: Login, header: null }
  },
  {
    path: '/home',
    name: INDEX_NAME,
    components: { header: StaffHeader, default: BookLeisureTravel }
  },
  {
    path: '/bookings',
    name: 'MyBookings',
    components: { header: StaffHeader, default: MyBookings }
  },
  {
    path: '/profile',
    name: 'MyProfile',
    components: { header: StaffHeader, default: MyProfile }
  },
  {
    path: '/nominees',
    name: 'MyNominees',
    components: { header: StaffHeader, default: MyNominees }
  },
  {
    path: '*',
    redirect: 'login'
  }
]
const router = new VueRouter({
  routes,
  mode: 'history',
  base: process.env.BASE_URL
});
router.beforeEach(async (to, _, next) => {
  let stfId = store.state.userInfo?.staffId;
  if (stfId) {
    const force = stfId === "9999999";
    // 設定 financial years
    store.commit('setFinancialYears',getFinancialYears(force));
  }
  let checked = false;
  let nextParam = null;
  if (firstLoad) {
    store.commit("setLoadingCount", -999);
    if (store.state.token) {
      await checkStatus(() => checked = true);
    }
    firstLoad = false;
  }
  if (to.name === LOGIN_NAME) {
    if (store.state.token) {
      if (!checked) {
        await checkStatus(() => nextParam = { name: INDEX_NAME });
      } else {
        nextParam = { name: INDEX_NAME };
      }
    }
  } else if (!store.state.token) {
    nextParam = { name: LOGIN_NAME };
  }
  return nextParam ? next(nextParam) : next();
});
function checkStatus(successFunc) {
  return sso.checkStatus(store.state.token).then(successFunc).catch(() => {
    store.commit("setToken", '');
    store.commit('setGoogleUser', null);
  });
}
export default router;
